<script>
import baseList from "@/views/components/base/baseList.vue";
export default {
  extends: baseList,
  components: {},
  data() {
    return {
      table: {
        mname: "receive",
        key: "id",
        url: {
          list: "/admin/system/receive/facility/list",
        },
        output: false,
      },
      actions: [
        { label: "入库记录", type: "info", onClick: this.toretrieval, auth: "" },
        { label: "领用记录", type: "info", onClick: this.tocheckout, auth: "" },
        { label: "盘点记录", type: "info", onClick: this.totakeStock, auth: "" },
        { label: "维修记录", type: "info", onClick: this.tomainten, auth: "" },
        { label: "损坏记录", type: "info", onClick: this.todamage, auth: "" },
        { label: "报废记录", type: "info", onClick: this.toscrap, auth: "" },
        { label: "关联记录", type: "info", onClick: this.toassociation, auth: "" },
      ],
      filters: [],
      tableCols: [
        {
          title: "序号",
          type: "index",
          width: 80,
          align: "center",
        },
        {
          title: "资产名称",
          key: "facilityName",
          minWidth: 100,
          align: "left",
          render: (h, params) => {
            const row = params.row;
            const text = row.facilityName;
            return <span style={{ "font-size": "14px" }}>{text}</span>;
          },
        },
        {
          title: "耗材名称",
          key: "inventoryName",
          minWidth: 120,
          align: "center",
        },
        {
          title: "耗材型号",
          key: "inventoryModel",
          minWidth: 120,
          align: "center",
        },
        {
          title: "领用时间",
          key: "createTime",
          minWidth: 120,
          align: "center",
        },
      ],
    };
  },
  created() {
    let query = this.$route.query;
    if (query.facilityId) {
      this.query.facilityId = query.facilityId;
    }
    this.facilityId = query.facilityId;
    this.facilityNo = query.facilityNo;
  },
  methods: {
    //入库记录
    toretrieval(row = {}) {
      let facilityId = this.facilityId;
      let facilityNo = this.facilityNo;
      $utils.url.replace({
        name: "deviceRecordretrieval_list",
        query: { facilityId: facilityId, facilityNo: facilityNo },
      });
    },
    //设备档案
    toreedit(row = {}) {
      $utils.url.push({
        name: "device_edit",
        query: { action: "view", kv: this.facilityId },
      });
    },
    //损坏记录
    todamage(row = {}) {
      let facilityId = this.facilityId;
      let facilityNo = this.facilityNo;
      $utils.url.replace({
        name: "deviceRecorddamage_list",
        query: { facilityId: facilityId, facilityNo: facilityNo },
      });
    },
    //出库记录
    tocheckout(row = {}) {
      let facilityId = this.facilityId;
      let facilityNo = this.facilityNo;
      $utils.url.replace({
        name: "deviceRecordcheckout_list",
        query: { facilityId: facilityId, facilityNo: facilityNo },
      });
    },
    totakeStock() {
      let facilityId = this.facilityId;
      let facilityNo = this.facilityNo;
      $utils.url.replace({
        name: "deviceTakeStockList_list",
        query: { facilityId: facilityId, facilityNo: facilityNo },
      });
    },
    //报废记录
    toscrap(row = {}) {
      let facilityId = this.facilityId;
      let facilityNo = this.facilityNo;
      $utils.url.replace({
        name: "deviceRecordscrap_list",
        query: { facilityId: facilityId, facilityNo: facilityNo },
      });
    },
    //维修记录
    tomainten(row = {}) {
      let facilityId = this.facilityId;
      let facilityNo = this.facilityNo;
      $utils.url.replace({
        name: "deviceMaintenance_list",
        query: { facilityId: facilityId, facilityNo: facilityNo },
      });
    },
    //关联记录
    toassociation(row = {}) {
      let facilityId = this.facilityId;
      let facilityNo = this.facilityNo;
      $utils.url.push({
        name: "deviceAssociation_list_cus",
        query: { facilityId: facilityId, facilityNo: facilityNo },
      });
    },
  },
};
</script>
<style scoped></style>
